import React, { Component } from "react"
import { Helmet } from "react-helmet"

import { Flex } from "grid-styled"
import { ImgScaled, H1, Ul, Page } from "../styled-components"

import bilder from "../bilder/page404"

class Page404 extends Component {
  render() {
    return (
      <div>
        <Helmet>
          <title>Fotografie Anders: 404</title>
        </Helmet>
        <Flex flexDirection="column" alignItems="center">
          <ImgScaled
            data-sizes="100vw"
            srcSet={bilder[1].min}
            // src={bilder[1].max}
            data-srcset={bilder[1].srcset}
            className="lazyload blur-up"
            alt="Bild 01"
            width="100%"
          />
        </Flex>
        <Page>
          <H1>404 — Ressource nicht gefunden</H1>

          <Ul>
            <li>
              {" "}
              Es tut uns leid, dass Sie die gesuchte Ressource nicht gefunden
              haben.
            </li>
            <li>
              {" "}
              Wahrscheinlich steht die Ressource jetzt an einer geeigneteren
              Stelle.
            </li>
            <li>
              {" "}
              Bitte gehen Sie zurück auf die <a href="/">Startseite</a> und
              schauen sich von dort noch einmal um.
            </li>
            <li>
              {" "}
              Falls Sie die Ressource immer noch nicht finden können, schreiben
              Sie uns bitte eine E-Mail.
            </li>
          </Ul>
        </Page>
      </div>
    )
  }
}

export default Page404



// WEBPACK FOOTER //
// ./src/pages/Page404.js